import { Dayjs } from '@util/dayjs'

export interface BasicFormValues {
    firstName?: string
    lastName?: string
    email?: string
    password?: string
    repeatPassword?: string
    birthday?: Dayjs
    gender?: TGender
    bornIn?: TLocation
    livingIn?: TLocation
    terms?: boolean
}

const initialFormValues: BasicFormValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    repeatPassword: '',
    birthday: undefined,
    gender: undefined,
    bornIn: undefined,
    livingIn: undefined,
    terms: false,
}

export { initialFormValues }
